/**
 * V1/V2 product label verification (tRPC, order-line service) and admin label
 * preview row keys — same enum values everywhere (`"V1"` / `"V2"`).
 */
export enum LabelVersion {
  V1 = "V1",
  V2 = "V2",
}

export type LabelVersionKey = LabelVersion | "genericV1" | "genericV2"

export type LabelVersionItem = {
  key: LabelVersionKey
  url: string
  isVerified: boolean | null
}
